import { Navigate, Outlet } from "react-router";
import { useAppSelector } from "@/hooks/storeHooks";

const WithSubscribe = () => {
  const user = useAppSelector((state) => state.user.user);

  // 1. Not logged in?
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const { subscribed, subscription_exp } = user;

  // 2. Not subscribed or missing expiration?
  if (!subscribed || !subscription_exp) {
    return <Navigate to="/subscription" replace />;
  }

  // 3. Parse expiration once, compare as numbers
  const expiresAt = Date.parse(subscription_exp); // returns ms or NaN
  if (isNaN(expiresAt) || expiresAt < Date.now()) {
    return <Navigate to="/subscription" replace />;
  }

  // 4. All good → render children routes
  return <Outlet />;
};

export default WithSubscribe;
